import React from 'react';
export function DiferencialHibrido() {
  return <section className="w-full overflow-hidden" data-id="element-135" data-mp="ov6uhgjetb3o">
      <img src="https://cdn.magicpatterns.com/uploads/6c8xf9X5cZWZfyiykvA77s/ChatGPT_Image_6_ago_2026,_22_59_05.webp" alt="Lo que empieza a ordenarse cuando tenés un sistema real" className="w-full h-auto block pt-[0px]" data-id="element-136" data-mp="241fzittfk4cn" />
    </section>;
}